import axios from "axios";
import jwt_decode from "jwt-decode";
import setAuthToken from "../../helpers/setAuthToken";
import { URL as url } from "../../config/config";

export const initialState = {
  isLoading: false,
  isAuthenticated: false,
  user: {},
  error: null,
  errmsg: "",
  requires2FA: false,
  twoFAData: null,
};

export const START_LOGIN = "Login/START_LOGIN";
export const LOGIN_SUCCESS = "Login/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "Login/LOGIN_FAILURE";
export const RESET_ERROR = "Login/RESET_ERROR";
export const LOGIN_USER = "Login/LOGIN_USER";
export const SIGN_OUT_SUCCESS = "Login/SIGN_OUT_SUCCESS";
export const REQUIRE_2FA = "Login/REQUIRE_2FA";
export const CLEAR_2FA = "Login/CLEAR_2FA";

export const startLogin = () => ({
  type: START_LOGIN,
});

export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

export const signOutSuccess = () => ({
  type: SIGN_OUT_SUCCESS,
});

export const loginFailure = (payload) => ({
  type: LOGIN_FAILURE,
  payload: payload,
});

export const resetError = (payload) => ({
  type: RESET_ERROR,
  payload: payload,
});

export const require2FA = (payload) => ({
  type: REQUIRE_2FA,
  payload,
});

export const clear2FA = () => ({
  type: CLEAR_2FA,
});

export const loginWithToken = (jwtToken) => async (dispatch) => {
  const data = await jwt_decode(jwtToken);
  localStorage.setItem("jwtToken", jwtToken);
  setAuthToken(jwtToken);
  dispatch(loginSuccess(data));
  window.location.reload();
};

export const loginUser = (userName, password, recaptchaToken) => (dispatch) => {
  dispatch(startLogin());
  dispatch(resetError());

  if (!!userName && !!password) {
    const user = {
      userName,
      password,
      recaptchaToken,
    };
    axios
      .post(url + "/auth/login", user)
      .then(async (res) => {
        if (res.data.requires2FA) {
          dispatch(
            require2FA({
              userName,
              maskedEmail: res.data.maskedEmail || "",
              maskedPhone: res.data.maskedPhone || "",
            }),
          );
          return;
        }
        const { token } = res.data;
        localStorage.setItem("jwtToken", token);
        const decoded = await jwt_decode(token);
        setAuthToken(token);
        dispatch(loginSuccess(decoded));
      })
      .catch((err) => {
        console.error(err);
        const data = err.response?.data;
        let msg =
          (data && typeof data === "object" && (data.message || data.error || data.errmsg)) ||
          (typeof data === "string" ? data : null);
        if (typeof msg !== "string") {
          msg = err.response?.status === 401
            ? "Invalid email/username or password."
            : "Unable to setup connection.";
        }
        dispatch(loginFailure({ errmsg: String(msg) }));
      });
  } else {
    dispatch(loginFailure({ errmsg: "fields cant be empty" }));
  }
};

export const verifyLoginOtp = (userName, otp) => (dispatch) => {
  dispatch(startLogin());
  dispatch(resetError());

  if (!userName || !otp || String(otp).trim().length !== 6) {
    dispatch(loginFailure({ errmsg: "Please enter the 6-digit code." }));
    return;
  }

  axios
    .post(url + "/auth/verify-login-otp", { userName, otp: String(otp).trim() })
    .then(async (res) => {
      const { token } = res.data;
      localStorage.setItem("jwtToken", token);
      const decoded = await jwt_decode(token);
      setAuthToken(token);
      dispatch(loginSuccess(decoded));
    })
    .catch((err) => {
      const data = err.response?.data;
      const attemptsRemaining =
        data && typeof data === "object" ? data.attemptsRemaining : undefined;
      const msg =
        (data && typeof data === "object" && data.message) ||
        (attemptsRemaining != null
          ? `Invalid code. ${attemptsRemaining} attempt(s) remaining. Click 'Back to sign in' to request a new code.`
          : typeof data === "string"
          ? data
          : "OTP expired or invalid. Click 'Back to sign in' to receive a new code.");
      dispatch(loginFailure({ errmsg: msg }));
    });
};

export const signOut = (_id) => (dispatch) => {
  localStorage.removeItem("jwtToken");
  dispatch(signOutSuccess());
  window.location.reload();
};

export const modifyUser = (token) => (dispatch) => {
  const decoded = jwt_decode(token);
  dispatch(loginSuccess(decoded));
};

export default function LoginReducer(state = initialState, { type, payload }) {
  switch (type) {
    case START_LOGIN:
      return {
        ...state,
        isLoading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        error: null,
        user: { ...payload },
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errmsg: typeof payload?.errmsg === "string" ? payload.errmsg : "Invalid login credentials.",
      };
    case RESET_ERROR:
      return {
        ...state,
        error: false,
      };
    case SIGN_OUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
      };
    case REQUIRE_2FA:
      return {
        ...state,
        isLoading: false,
        requires2FA: true,
        twoFAData: payload,
        error: false,
        errmsg: "",
      };
    case CLEAR_2FA:
      return {
        ...state,
        requires2FA: false,
        twoFAData: null,
        error: false,
        errmsg: "",
      };
    default:
      return state;
  }
}
